"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

var styles = {
  "message": "message-message-1Phba",
  "success": "message-success-lj-3w",
  "warning": "message-warning-3Jeo3",
  "danger": "message-danger-3S8ZE",
  "fill": "message-fill-2beF5"
};

var Message = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      variant = _ref.variant,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'p' : _ref$tag,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? false : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "className", "variant", "tag", "fill"]);
  return /*#__PURE__*/_react["default"].createElement(Tag, (0, _extends2["default"])({
    ref: ref,
    className: _utils.classNames.use('message', variant, fill && 'fill').from(styles).join(className)
  }, restProps), children);
});

Message.propTypes = {
  /**
   * Defines color scheme of the message
   */
  variant: _propTypes["default"].oneOf(['success', 'warning', 'danger']),

  /**
   * Indicates whether message should have colored or transparent background
   */
  fill: _propTypes["default"].bool
};
Message.defaultProps = {
  fill: false
};
var _default = Message;
exports["default"] = _default;